var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    {
      staticClass: "flex-1 lg:flex-[2]",
      attrs: { title: _vm.$t("salesByInstallmentsTitle"), hasPadding: "" },
    },
    [
      [
        _c(
          "dash-card-content-fallback",
          { attrs: { hasData: _vm.hasData } },
          [
            _c("jade-text", { attrs: { size: "small" } }, [
              _vm._v(" " + _vm._s(_vm.$t("titleNumberTransactions")) + " "),
            ]),
            _c("chart-bar-installments", { attrs: { data: _vm.installments } }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }